import Telemedicina from "./Telemedicina";

export default Telemedicina;
